/** The optional perf overlay (`?perf=1`): frames per second of the page, the 2D view's React renders per
 * second, the 3D view's drawn frames, its pixel ratio and render time. Updates twice a second from counters the
 * views bump (perf.ts), so it never re-renders the editor. */
import { useEffect, useRef, useState } from "react";
import { FrameMeter, perfCounters } from "./perf.ts";

export function PerfOverlay() {
  const [text, setText] = useState("");
  const meter = useRef(new FrameMeter(120));
  useEffect(() => {
    let raf = 0;
    let last = performance.now();
    const tick = (t: number) => {
      meter.current.add(t - last);
      last = t;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    let prev = { ...perfCounters, at: performance.now() };
    const timer = window.setInterval(() => {
      const now = performance.now();
      const s = (now - prev.at) / 1000;
      const { fps, p95Ms } = meter.current.stats();
      const renders = (perfCounters.topViewRenders - prev.topViewRenders) / s;
      const frames3d = (perfCounters.threeFrames - prev.threeFrames) / s;
      setText(
        `page ${fps.toFixed(0)} fps · p95 ${p95Ms.toFixed(1)} ms\n2D renders ${renders.toFixed(1)}/s\n3D frames ${frames3d.toFixed(1)}/s · dpr ${perfCounters.threeDpr || "—"} · draw ${perfCounters.threeFrameMs.toFixed(1)} ms`,
      );
      prev = { ...perfCounters, at: now };
    }, 500);
    return () => {
      cancelAnimationFrame(raf);
      window.clearInterval(timer);
    };
  }, []);
  return (
    <pre className="perf-overlay" aria-hidden="true">
      {text}
    </pre>
  );
}
